import pwaConfig from '@/configs/custom.config';
import i18n from '@/i18n/i18n';
import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import ar from 'vuetify/lib/locale/ar';
import en from 'vuetify/lib/locale/en';

import colors from 'vuetify/lib/util/colors'
Vue.use(Vuetify);

export default new Vuetify({
	rtl: i18n.locale === 'ar',
	lang: {
		locales: { en, ar },
		current: i18n.locale,	
	},
	theme: {
		themes: {
			light: {
				primary: pwaConfig.primaryColor, // #0886a5 #253c99 #E53935
				secondary: pwaConfig.secondaryColor, // #f57f20 #13a689 #FFCDD2
				lightgray: colors.grey.lighten5,
				// success: '#13a689',
				error: '#ff3334',
				errorLight: '#eeb4b3',
				green: '#0f8145',
			},
		},
	},
});
